import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { callsApi } from '../api/callsApi';
import { callsKeys } from '../queryKeys';

export function useSyncCalls() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  const sync = useMutation({
    mutationFn: () => callsApi.syncCalls(locationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: callsKeys.log(locationId) });
      queryClient.invalidateQueries({ queryKey: callsKeys.stats(locationId) });
      queryClient.invalidateQueries({ queryKey: callsKeys.attribution(locationId) });
    },
  });

  return { sync, locationId };
}
